import { SwitchInput, useFormContext } from "@4uhub/lib4uhub";
import { useTranslation } from "react-i18next";
import { TTicketServiceAreaForm } from "./TicketServiceAreaSchema";
import { useWatch } from "react-hook-form";
import { useEffect } from "react";

const translationPath = "chatBot.page.service.ticketServiceArea.";

export const IsIdentification = () => {
  const { t } = useTranslation();

  const { control, setValue } = useFormContext<TTicketServiceAreaForm>();

  const actionSelector = useWatch({ control, name: "actionSelector" });

  const showIsIdentification = actionSelector?.code !== "4";

  useEffect(() => {
    if (!showIsIdentification) {
      setValue("isIdentification", false);
    }
  }, [actionSelector]);

  return (
    <>
      {showIsIdentification && (
        <SwitchInput
          name="isIdentification"
          label={t(translationPath + "identification")}
        />
      )}
    </>
  );
};
